import React, { useEffect, useMemo, useState } from 'react';
import PackagesHeader from '../features/Packages/components/PackagesHeader';
import PackagesView from '../features/Packages/components/PackagesView';
import CreatePackageForm from '../features/Packages/components/CreatePackageForm';
import EditPackageForm from '../features/Packages/components/EditPackageForm';
import { BillingPackage } from '../features/Packages/types/BillingPackage';
import { usePackagesStore } from '../features/Packages/store/packagesStore';
import { PuffLoader } from 'react-spinners';

const PackagesContent: React.FC = () => {
    const { packages, fetchAllPackages } = usePackagesStore();
    const [activeTab, setActiveTab] = useState('All');
    const [selectedService, setSelectedService] = useState('All');
    const [showForm, setShowForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [selectedPackage, setSelectedPackage] = useState<BillingPackage | null>(null);
    const [loading, setLoading] = useState(false);

        useEffect(() => {
            const loadPackages = async () => {
                if (packages.length === 0) {
                    setLoading(true);
                    await fetchAllPackages();
                    setLoading(false);
                }
            };
    
            loadPackages();
        }, [packages, fetchAllPackages]);

    // Filter packages based on active tab
    const filteredPackages = useMemo(() => {
        return packages.filter(pkg => {
            // Always show if both filters are 'All'
            if (activeTab === 'All' && selectedService === 'All') {
                return true;
            }

            // Filter by status if not 'All'
            // const statusMatch = activeTab === 'All' || pkg.status === activeTab;

            // Filter by service if not 'All'
            const serviceMatch = selectedService === 'All' ||
                pkg.service_name.toLowerCase() === selectedService.toLowerCase();

            return serviceMatch;
        });
    }, [activeTab, selectedService, packages]);

    const handleEditPackage = (pkg: BillingPackage) => {
        setSelectedPackage(pkg);
        setShowEditForm(true);
    };

    if (loading) {
        return <div className='w-full flex flex-col items-center justify-center h-full'><PuffLoader color="#FFFFFF" /></div>;
    }

    return (
        <div className="w-full flex gap-x-4">
            <div className="w-[55%] h-screen overflow-y-auto py-6">
                <PackagesHeader onShowForm={() => setShowForm(true)} activeTab={activeTab} setActiveTab={setActiveTab} selectedService={selectedService} setSelectedService={setSelectedService} />
                <PackagesView packages={filteredPackages} onEdit={handleEditPackage} />
            </div>
            {showForm ? (
                <div className='w-[45%] h-screen border-l border-white px-2'>
                    <CreatePackageForm onClose={() => setShowForm(false)} />
                </div>
            ) : (
                <div className="text-white text-center py-20"></div>
            )}

            {showEditForm ? (
                <div className='w-[45%] h-screen border-l border-white px-2'>
                    <EditPackageForm onClose={() => setShowEditForm(false)} selectedPackage={selectedPackage} />
                </div>
            ) : (
                <div className="text-white text-center py-20"></div>
            )}
        </div>
    );
};

export default PackagesContent;
